import { useSoftDeployAccess } from 'App/components/hooks';

export default function useTaskListAllowed() {
	return useSoftDeployAccess('TODO_LIST');
}
